import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-adobe-tip-modal',
  templateUrl: './adobe-tip-modal.component.html',
  styleUrls: ['./adobe-tip-modal.component.scss'],
})
export class AdobeTipModalComponent {
  constructor(private dialogRef: MatDialogRef<AdobeTipModalComponent>) {}
  close() {
    this.dialogRef.close();
  }

  onOk() {
    this.dialogRef.close('ok');
  }
}
